module.exports = __webpack_public_path__ + "img/figure-2.2b88ac83.png";